import types from 'redux/types';

const getListUser = () => ({
  type: types.REQUEST_MANAGE_USER,
});

const signAsUser = (data) => ({
  type: types.REQUEST_CHANGE_USER,
  ...data,
});

export default {
  getListUser,
  signAsUser,
};
